module.exports = __webpack_public_path__ + "img/choose.beaf0301.svg";